import { styled } from "@mui/material";

// ── shared với MonthRangePicker ────────────────────────────────────────────
export const Wrapper = styled("div")({
  position: "relative",
  minWidth: "200px",
  backgroundColor: "#ffffff",
  border: "1px solid #e5e7eb",
  borderRadius: "5px",
  userSelect: "none",
  boxSizing: "border-box",
});

export const Toggle = styled("button")({
  width: "100%",
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "6px 10px",
  background: "transparent",
  border: "none",
  borderRadius: "5px",
  cursor: "pointer",
  textAlign: "left",
  font: "inherit",
  color: "inherit",
  "&:focus-visible": {
    outline: "2px solid #1d7f7a",
    outlineOffset: "2px",
  },
});

export const Popup = styled("div")<{ menuPlacement?: "left" | "right" }>(
  ({ menuPlacement = "left" }) => ({
    position: "absolute",
    top: "35px",
    left: menuPlacement === "right" ? "auto" : "0",
    right: menuPlacement === "right" ? "0" : "auto",
    zIndex: 99999,
    width: "300px",
    backgroundColor: "#ffffff",
    border: "1px solid #eeeeee",
    borderRadius: "5px",
    boxShadow: "0 0 10px 0 rgba(0, 0, 0, 0.2)",
    "& *": { boxSizing: "border-box" },
    "@media (max-width: 425px)": {
      width: "100%",
    },
  })
);

export const Presets = styled("div")({
  padding: "20px",
  borderBottom: "1px solid #eeeeee",
});

export const Calendar = styled("div")({
  padding: "20px",
});

export const SectionTitle = styled("div")({
  marginBottom: "12px",
  color: "#575757",
  fontSize: "0.75rem",
  fontWeight: 600,
  textTransform: "uppercase",
  userSelect: "none",
});

export const PresetButton = styled("button")({
  display: "block",
  padding: 0,
  margin: 0,
  border: "none",
  background: "none",
  font: "inherit",
  fontWeight: 700,
  color: "inherit",
  cursor: "pointer",
  textAlign: "left",
  "&:focus-visible": {
    outline: "2px solid #1d7f7a",
    outlineOffset: "2px",
  },
  "& + &": { marginTop: "8px" },
});

export const CalendarHeader = styled("div")({
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  gap: "8px",
  marginBottom: "12px",
});

export const MonthYear = styled("div")({
  userSelect: "none",
  fontWeight: 600,
  fontSize: "0.9rem",
});

export const NavButton = styled("button")({
  width: "24px",
  height: "24px",
  flexShrink: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: 0,
  border: "none",
  background: "transparent",
  color: "inherit",
  cursor: "pointer",
  borderRadius: "4px",
  transition: "opacity 0.2s ease",
  "&:hover": { opacity: 0.7 },
  "&:focus-visible": {
    outline: "2px solid #1d7f7a",
    outlineOffset: "2px",
  },
  "&.disabled": {
    opacity: 0.2,
    cursor: "default",
    pointerEvents: "none",
  },
});

// ── date-picker specific ───────────────────────────────────────────────────
export const WeekdayRow = styled("div")({
  display: "grid",
  gridTemplateColumns: "repeat(7, 1fr)",
  gap: "2px",
  marginBottom: "4px",
});

export const WeekdayLabel = styled("div")({
  textAlign: "center",
  fontSize: "0.7rem",
  fontWeight: 600,
  color: "#aaa",
  padding: "2px 0",
  userSelect: "none",
});

export const DateGrid = styled("div")({
  display: "grid",
  gridTemplateColumns: "repeat(7, 1fr)",
  gap: "2px",
});

export const DateButton = styled("button")<{
  isSelected?: boolean;
  isInRange?: boolean;
  isDisabled?: boolean;
  isToday?: boolean;
  isOtherMonth?: boolean;
  highlightCol?: string;
}>(
  ({
    isSelected,
    isInRange,
    isDisabled,
    isToday,
    isOtherMonth,
    highlightCol = "#1d7f7a",
  }) => ({
    width: "100%",
    aspectRatio: "1",
    padding: 0,
    border: `1px solid ${
      isSelected ? highlightCol : isToday ? `${highlightCol}88` : "transparent"
    }`,
    borderRadius: "6px",
    backgroundColor: isSelected
      ? highlightCol
      : isInRange
      ? `${highlightCol}22`
      : "transparent",
    textAlign: "center",
    cursor: isDisabled || isOtherMonth ? "default" : "pointer",
    font: "inherit",
    fontSize: "0.8rem",
    color: isSelected
      ? "#ffffff"
      : isOtherMonth || isDisabled
      ? "#ccc"
      : "inherit",
    fontWeight: isToday && !isSelected ? 700 : 400,
    transition:
      "background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease",
    "&:hover:not(:disabled)": {
      backgroundColor:
        !isOtherMonth && !isDisabled
          ? isSelected
            ? highlightCol
            : `${highlightCol}33`
          : undefined,
    },
    "&:focus-visible": {
      outline: `2px solid ${highlightCol}`,
      outlineOffset: "2px",
    },
    pointerEvents: isDisabled || isOtherMonth ? "none" : "auto",
  })
);
